import { markRaw } from 'vue';

// Store only pagination depth; each visit still fetches fresh, authorized data.
export function readSessionPages(key) {
    try {
        const pages = Number(sessionStorage.getItem(key));
        return Number.isSafeInteger(pages) && pages > 0 ? pages : 1;
    } catch {
        return 1;
    }
}

export function writeSessionPages(key, pages) {
    try {
        sessionStorage.setItem(key, String(pages));
    } catch {
        // Storage may be disabled or full. Pagination should still work.
    }
}

export function createSessionPagination(...scope) {
    const key = `pagination:${JSON.stringify(scope)}`;
    const target = readSessionPages(key);
    let pages = 1;
    let restoring = false;
    return markRaw({
        loaded() {
            pages += 1;
            if (!restoring) writeSessionPages(key, pages);
        },
        async restore(loadMore) {
            restoring = true;
            try {
                while (pages < target) {
                    const previous = pages;
                    if (!await loadMore() || pages === previous) break;
                }
            } finally {
                restoring = false;
            }
        }
    });
}
